import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import StarRatings from 'react-star-ratings';

import {
  CardContainer,
  CardHeader,
  CardRow,
  ReviewAuthor,
  ReviewDate,
  ReviewDescription,
  MoreLink,
} from './styles';

const renderDescription = (description, isOpen) => {
  let content;

  if (description.length > 200) {
    content = (
      <ReviewDescription>
        {isOpen ? description : `${description.slice(0, 200)}...`}
      </ReviewDescription>
    );
  } else {
    content = <ReviewDescription>{description}</ReviewDescription>;
  }

  return content;
};

const ReviewCard = ({ author, date, rating, description }) => {
  const [isOpen, handleButtonClick] = useState(false);

  return (
    <CardContainer>
      <CardHeader>
        <CardRow>
          <ReviewAuthor>{author || 'Unknown Author'}</ReviewAuthor>
          <ReviewDate>{moment(date).format('ddd, MMM DD YYYY')}</ReviewDate>
        </CardRow>
        <CardRow>
          <StarRatings rating={rating || 5} numberOfStars={5} starRatedColor="#1eb6ff" starEmptyColor="#b6e4f9" starDimension="15px" starSpacing="0px" />
        </CardRow>
      </CardHeader>
      {description && description.length > 0 ? renderDescription(description, isOpen) : null}
      {description && description.length > 200 && (
        <MoreLink onClick={() => handleButtonClick(!isOpen)}>{isOpen ? 'Hide' : 'More...'}</MoreLink>
      )}
    </CardContainer>
  )
};

ReviewCard.propTypes = {
  author: PropTypes.string,
  date: PropTypes.string,
  rating: PropTypes.number,
  description: PropTypes.string,
};

export default ReviewCard;
